export default (node => {
  var Carousel = node.querySelector('[data-cms-title="Carousel Speed"]');
  var Data = JSON.parse(node.getAttribute('data-promo-bars'));
  return {
    Data,
    Carousel: Carousel === null || Carousel === void 0 ? void 0 : Carousel.innerHTML
  };
});